// Define Angular modules for evo.Trip.App
// Extended in other files.
(function (ng) {
    ng.module('evo.Trip.Services', []);
    ng.module('evo.Trip.Controllers', []);
    ng.module('evo.Trip.Filters', []);
    ng.module('evo.Shared.Services', []);
    ng.module('evo.Trip.App', ['evo.Trip.Filters', 'evo.Trip.Controllers', 'evo.Trip.Services', 'evo.Shared.Services'
    ]).config(['$locationProvider', function ($locationProvider) {
        $locationProvider.html5Mode({
            enabled: true, requireBase: false, rewriteLinks: false
        });
    }]);
})(angular);